import allocatedModel from "./component/allocatedModel.vue";
import useApi from "@/api/useApi.js";

const sourceMap = ["list", "yqprice", "", ""];

const baseData = {
  state: {
    switch: true,
    type: "info"
  }
  // state: {
  //   switch: false,
  //   type: "primary"
  // }
};

const list = [
  {
    name: "未分配案件总数：",
    value: "0条",
    button: { type: "info", disabledKey: "switch" },
    data: "todo_yuqi"
  },
  { name: "未分配案件逾期金额：", value: "0条", data: "yuqi_price" },
  { name: "今日未分配案件数：", value: "0条", data: "today_todo_yuqi" },
  { name: "今日未分配案件逾期金额：", value: "0条", data: "today_yuqi_price" }
];

const funcs = {};

funcs.openModel = function() {
  this.$refs.dialogRef.init();
};

funcs.getCollectionCaseList = async function() {
  const { data } = await useApi().getCollectionCaseList({});
  this.list.forEach(item => {  
    const value = data[item.data] || "0"; 
    if (item.name.indexOf("金额") == -1) {
      item.value = `${value}条`;       
    }else{
      item.value = `${value}元`;       
    }
  });  
  if (data['todo_yuqi'] > 0) {
    this.state["switch"] = false;
    this.state["type"] = "primary";
  }else{
    this.state["switch"] = true;
    this.state["type"] = "info";
  }
};
async function parentMethod() {  
  await this.getCollectionCaseList();
} 
async function dataInit() {
  await this.getCollectionCaseList();
}

export default {
  name: "Index",
  props: {},
  components: {
    allocatedModel
  },
  data() {
    return { list, ...baseData };
  },
  methods: { parentMethod,...funcs },
  created: dataInit
};



// WEBPACK FOOTER //
// ./src/views/collection/allocated_cases/contact.js